<template>
  <div class="w-100 wrapper-premium-group">
    <div class="card shadow overflow-hidden p-0 mx-0 mb-4">
      <div class="row">
        <div class="col-md-12">
          <form class="w-100" method="post" novalidate @submit.prevent="submitForm">
            <div class="card-body px-4 pt-4 pb-2">
              <h5 class="font-PB text-primary text-center py-2 mb-4">Cotizá tu garantía inmobiliaria con PREMIUM GROUP
              </h5>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group row flex-column" :class="{ error: form.valorError.value }">
                    <label class="col font-PM text-gray mb-3" for="valor">Ingresá el valor mensual del alquiler</label>
                    <div class="col">
                      <div class="content-element bg-white border border-borders rounded overflow-hidden">
                        <div class="element-form-ico w-100 text-primary d-flex align-items-stretch">
                          <div class="bg-light d-flex justify-content-center align-items-center p-2">
                            <h4 class="h4-md font-PB text-nowrap px-1 px-sm-2 mb-0">$ARS</h4>
                          </div>
                          <input ref="valor" type="number"
                            class="form-control h-auto h4-md border-0 text-primary text-left py-0 font-AR" id="valor"
                            placeholder="50.000" maxlength="8" v-model="form.valor">
                        </div>
                      </div>
                      <p class="error-messages small text-danger my-2 font-PM" v-if="form.valorError.value">{{
                        form.valorError.value }}</p>
                    </div>
                  </div>
                </div>
                <!-- Otros campos del formulario -->
              </div>
            </div>
            <div class="card-footer bg-transparent border-0 px-4 pt-0 pb-0">
              <div class="row justify-content-center align-items-center">
                <div class="col-md-12">
                  <div class="row no-gutters flex-column align-items-center justify-content-center">
                    <button type="submit"
                      class="btn btn-outline-primary rounded-pill cta-start mb-3 text-uppercase font-ARB btn-square"
                      :disabled="isButtonDisabled">Ver resultado
                    </button>
                    <a href="https://www.premiumgroup.com.ar/" target="_blank"
                      class="btn btn-link hover-unlin text-primary mb-2">
                      <h4 class="font-ARB text-primary">
                        www.premiumgroup.com.ar</h4>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <!--resultado-->
        <div class="col-lg-12" v-if="form.submitted">
          <!-- Contenido del resultado -->
        </div>
        <!--fin resultado-->
      </div>
    </div>
    <!--Aclaraciones-->
    <div class="col-md-12">
      <p class="small font-R text-gray"><b>Aclaración:</b> Los valores son calculados según los montos ingresados. El
        costo final corresponderá al mismo cálculo en base a los valores que figuren en el contrato de locación.<br><br>
      </p>
      <p class="font-R text-gray font-weight-bold">Comerciales, vieja ley y montos altos: solicitar cotización.
      </p>
    </div>
  </div>
</template>



<script>
import { reactive, computed } from 'vue';

export default {
  setup() {
    const form = reactive({
      submitted: false,
      valor: '',
      valorError: ''
    });

    const isButtonDisabled = computed(() => !form.valor);

    const submitForm = () => {
      const isValid = validateForm();
      if (isValid) {
        form.submitted = true;
      }
    };

    const validateForm = () => {
      form.valorError = '';
      let isValid = true;

      if (!form.valor) {
        form.valorError = 'Por favor, ingresa el valor mensual del alquiler';
        isValid = false;
      }

      return isValid;
    };

    return {
      form,
      submitForm,
      isButtonDisabled
    };
  }
};
</script>

<style lang="scss">
//setteo
@import "./resources/scss/partials/color";
@import "./resources/scss/partials/mixins";

$premiumGroup: #921E5C;

//Body
.wrapper-premium-group {
  .list-group {
    li {
      &>.row {
        min-height: 80px;
      }
    }
  }

  .list-head {
    background-color: $lightGray5 !important;
  }

  .btn-link {

    &.text-primary:hover,
    &.text-primary:focus {
      color: $premiumGroup !important;
    }
  }

  .text-primary {
    color: $premiumGroup !important;
  }

  .bg-primary {
    background-color: $premiumGroup !important;
  }

  .btn {
    &[class*="btn-outline-primary"] {
      color: $premiumGroup !important;

      &:disabled {
        color: $premiumGroup !important;

        &:hover {
          background-color: transparent !important;
        }
      }
    }

    &[class*="btn-outline-light"] {

      &:hover,
      &:focus,
      &:visited,
      &:link {
        color: $premiumGroup !important;
      }
    }

    &-outline-primary {
      border-color: $premiumGroup !important;

      &:hover,
      &:focus,
      &:visited,
      &:link {
        background-color: $premiumGroup !important;
        border-color: $premiumGroup !important;
        color: $white !important;
      }
    }

    &-secondary {
      background-color: $light2 !important;
      border-color: $light2 !important;

      &:hover,
      &:focus {
        background-color: $lightGray !important;
        border-color: $lightGray !important;
        color: #ffffff !important;
      }
    }
  }

  .form-control:focus-visible {
    text-shadow: 0 0 0 $lightGray3 !important;
  }

  .wrapper-select-search {
    .multiselect {
      .multiselect__placeholder {
        color: rgba(0, 0, 0, .4) !important;
      }

      .multiselect__option--highlight {
        background: $premiumGroup !important;
      }

      .multiselect__tags {
        input {
          color: #4A4A4A !important;
        }

        .multiselect__single {
          color: #4A4A4A !important;
        }
      }

      &.multiselect--active {
        .multiselect__tags {
          background-color: rgba(0, 0, 0, .03) !important;
        }
      }
    }
  }
}
</style>
